import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetCart } from '../../Hooks/user/user.get.hooks';
import { getGuestCart } from '../../Routes/MainComponents/navigation/GuestCart';
import PropTypes from 'prop-types';
import PageError from '../../Components/PageErrorState/PageErrorState';
import PageLoading from '../../Components/PageLoadingState/PageLoadingState';
import Auth from '../../Helpers/auth';

// For the cart
const CartDataProvider = ({ children }) => {
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage?.getItem('temp_id');

  // If user is not authenticated (no token) use guest cart stored in localStorage
  if (!Auth.getToken()) {
    const {
      data: guestCartData,
      isLoading: guestLoading,
      isError: guestError,
      refetch,
    } = useQuery({
      queryKey: ['cart', 'guest'],
      queryFn: async () => {
        const guestCart = getGuestCart();
        return (guestCart || []).map((item) => ({
          courseId: item.courseId || item._id || item.id,
          courseName: item.courseName || item.title || item.name || '',
          price: Number(item.price) || 0,
          _id: item._id || item.courseId || item.id,
          ...item,
        }));
      },
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    });
    // Listen for guest cart updates and refetch
    React.useEffect(() => {
      const handler = () => refetch();
      window.addEventListener('guest-cart-updated', handler);
      return () => window.removeEventListener('guest-cart-updated', handler);
    }, [refetch]);

    if (guestLoading) return children([]);
    if (guestError) return children([]);

    return children(guestCartData || []);
  }

  const {
    data: cart,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['cart', userId],
    queryFn: () => httpGetCart(userId),
    enabled: !!userId,
    retry: 2,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  if (isLoading)
    return (
      <PageLoading
        title="Loading Cart..."
        description="Fetching cart data for you."
      />
    );
  if (isError)
    return (
      <PageError
        title="Error Loading Cart"
        description="We were unable to load the cart data. Please try again later."
      />
    );

  return children(cart);
};
CartDataProvider.propTypes = {
  //   userId: PropTypes.string,
  //   courseId: PropTypes.string,
  children: PropTypes.func,
};

export default CartDataProvider;
